import { useState } from 'react';
import { UserVisitsPage, UserVisitsHeader, UserVisitsBody } from './UserVisitsComponents';
import { RoleGuard } from '../../routes';

export const UserVisits = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <UserVisitsPage innerScroll>
        <UserVisitsHeader totalCount={totalCount} />
        <UserVisitsBody setTotalCount={setTotalCount} />
      </UserVisitsPage>
    </RoleGuard>
  );
};
